import React from "react";
import { Chip, Link, Paper } from "@mui/material";
import { pxToRem } from "../../utils/fontSizeUtility";

export interface ChipListProps {
  valuesArray: string[];
  setSelectedValues: (values: string[]) => void;
  paddingBottom?: number;
}
export const ChipList = ({ valuesArray, setSelectedValues, paddingBottom }: ChipListProps) => {
  function deleteSelectedValue(stringValue: string) {
    setSelectedValues([...valuesArray.filter((value) => value !== stringValue)]);
  }

  function clearAllValues() {
    setSelectedValues([]);
  }

  function getClearAllChip(chipCount: number) {
    return chipCount >= 2 ? (
      <Link
        href={"#"}
        key={"Clear filters"}
        onClick={clearAllValues}
        sx={{
          marginLeft: pxToRem(8),
          marginBottom: pxToRem(4),
          marginRight: pxToRem(4),
          color: "primary.main",
        }}
      >
        Clear filters
      </Link>
    ) : null;
  }

  return (
    <div>
      {valuesArray.length > 0 ? (
        <Paper
          elevation={0}
          sx={{
            backgroundColor: "inherit",
            marginTop: pxToRem(-10),
            paddingBottom: pxToRem(paddingBottom ?? 16),
          }}
        >
          {valuesArray.map((value) => (
            <Chip
              label={value}
              variant="outlined"
              onDelete={() => deleteSelectedValue(value)}
              key={value}
              color={"primary"}
              sx={{
                marginBottom: pxToRem(4),
                marginRight: pxToRem(4),
                borderRadius: "2px",
              }}
            />
          ))}
          {getClearAllChip(valuesArray.length)}
        </Paper>
      ) : null}
    </div>
  );
};
